import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { ETLBasefeed, ETLReportingSetObj, HierarchyGroup, GroupSubjectType} from './cxone-etl-reporting-set.model';
import { ApiResponse } from 'src/AngularJS/Models/api-response.model';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
@Injectable({
    providedIn: 'root'
})
export class CxoneEtlReportingSetService {
    private reportingSet: ETLReportingSetObj[];
    private reportingSetData: ETLReportingSetObj;
    private groupSubject: BehaviorSubject<GroupSubjectType> = new BehaviorSubject<GroupSubjectType>({} as GroupSubjectType);

    constructor(
        private cvApiService: CVApiService,
    ) { }

    public async loadReportingSet(): Promise<ETLReportingSetObj[]> {
        try {
            const response = await this.cvApiService.get<ETLReportingSetObj[]>(`/api/v1/pipeline-config/reporting-set-definitions`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (error) {
            console.error(`Failed to load reporting sets.`);
            throw error;
        }
    }

    public async getReportingSetDependencies(id: string): Promise<string[]> {
        try {
            const response = await this.cvApiService.get<string[]>(`/api/v1/pipeline-config/reporting-set-rdepends?id=${id}`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (error) {
            console.error(`Failed to retrive reporting set dependencies ${id}.`);
            throw error;
        }
    }

    public async deleteReportingSet(id: string): Promise<void> {
        try {
            const response = await this.cvApiService.delete<void>(`/api/v1/pipeline-config/reporting-set?id=${id}`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (error) {
            console.error(`Failed to delete reporting set ${id}.`);
            throw error;
        }
    }

    public async reactivateReportingSet(id: string): Promise<ApiResponse<void>> {
        try {
            const response = await this.cvApiService.post<void>(`/api/v2/pipeline/reporting-set-definition/${id}/reactivate`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response;
            else throw response;
        }
        catch (error) {
            console.error(`Failed to reactivate reporting set ${id}.`);
            throw error;
        }
    }

    public async hierarchyDefinitions() {
        try {
            const response = await this.cvApiService.get<any>(`/api/v1/pipeline-config/hierarchy-definitions`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response;
            else throw response;
        }
        catch (error) {
            console.error(`Failed to load hierarchy-definitions.`);
            throw error;
        }
    }

    public async loadBasefeed(): Promise<ETLBasefeed[]> {
        try {
            const response = await this.cvApiService.get<ETLBasefeed[]>(`/api/v1/pipeline-config/raw-data-definitions`);
            if (response.status_code >= 200 && response.status_code < 300) {
                const filteredData = response.data.map(item => ({
                    ...item,
                    DataList: item.DataList.filter(dataItem => dataItem.isActive === true)
                }));
                return filteredData;
            }
            else {
                throw response;
            }
        }
        catch (error) {
            throw error;
        }
    }

    async getPermissions(requestedPage: string) {
        try {
            const response = await this.cvApiService.get<string[]>(`/api/v1/general/pages/user-permissions/${requestedPage}`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (error) {
            throw error;
        }
    }


    public async createReportingSetDefination(payload): Promise<ApiResponse<void>> {
        try {
            const response = await this.cvApiService.post<void>(`/api/v1/pipeline-config/reporting-set-definitions`, payload);
            if (response.status_code >= 200 && response.status_code < 300)
                return response; else throw response;
        }
        catch (error) {
            throw error;
        }
    }

    async getHierarchyGroups() {
        try {
            const response = await this.cvApiService.get<HierarchyGroup[]>(`/api/v1/pipeline-config/group-types`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (error) {
            throw error;
        }
    }

    public async submitReportingSetDefinitions(payload: ETLReportingSetObj) {
        try {
            const response = await this.cvApiService.post<ETLReportingSetObj>(`/api/v1/pipeline-config/reporting-set-definitions`, payload);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (error) {
            console.error(`Failed to load reporting sets.`);
            throw error;
        }
    }

    public getReportingSet(): ETLReportingSetObj[] {
        return this.reportingSet;
    }

    public setReportingSet(reportingSet: ETLReportingSetObj[]): void {
        this.reportingSet = reportingSet;
    }

    public getReportingSetData(): ETLReportingSetObj {
        return this.reportingSetData;
    }

    public setReportingSetData(data: ETLReportingSetObj): void {
        this.reportingSetData = data;
    }

    updateData(value: GroupSubjectType): void {
        this.groupSubject.next(value);
    }

    getData(): BehaviorSubject<GroupSubjectType> {
        return this.groupSubject;
    }
}
